module.exports = __webpack_public_path__ + "static/img/040906.1d3ce517.png";